import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SvgIconModule } from '../../../svg-icon/svg-icon.module';
import { ConfirmWithOptionsComponent } from './confirm-with-options.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SvgIconModule,
    ],
    exports: [ ConfirmWithOptionsComponent ],
    declarations: [ ConfirmWithOptionsComponent ],
    entryComponents: [ ConfirmWithOptionsComponent ],
})
export class ConfirmWithOptionsModule {}
